(ns bec-cljs-common.components.input
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [bec-cljs-common.i18n :as i18n]
            [bec-cljs-common.utils.interop :as interop]))

(defn input-regex [props]
  (let [regex-type (or (:regex-type props) props)
        regex (:regex props)]
    (case regex-type
      :alphanumeric #"^[a-zA-Z0-9]{1,50}$"
      :capital-alphanumeric #"^[A-Z0-9]{1,50}$"
      :capital-alphanumeric-with-hyphen #"^[A-Z0-9-]{1,50}$"
      :number #"^[0-9.-]{2,50}$"
      :email #"^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$"
      regex)))

(defn validate-user-input [input regex-info]
  (if (and (not (nil? input)) (string? input))
    (string? (first (re-seq (input-regex regex-info) input)))))

(rf/reg-event-fx
  :keyboard-button-press
  (fn [{:keys [db]} [_ props]]
    (let [keypad-id (:keypad-id props)
          input (:input props)
          regex-props (:regex-props props)
          input-max-length (:input-max-length props)
          key-press-event-fn (:key-press-event-fn props)
          regex-result (when regex-props (validate-user-input input regex-props))
          input-max-length (or input-max-length 50)]
      (if (>= input-max-length (count input))
        (merge
          {:db (cond
                 key-press-event-fn
                 (-> (assoc-in db [:keypad keypad-id :input] input)
                   (assoc-in [:keypad keypad-id :input-prompt] nil))
                 regex-props
                 (-> (assoc-in db [:keypad keypad-id :input] input)
                   (assoc-in [:keypad keypad-id :valid-input?] regex-result)
                   (assoc-in [:keypad keypad-id :input-prompt] nil))
                 :else
                 (-> (assoc-in db [:keypad keypad-id :input] input)
                   (assoc-in [:keypad keypad-id :input-prompt] nil)
                   (assoc-in [:keypad keypad-id :valid-input?] nil)))}
          (when (fn? key-press-event-fn)
            (let [function-result (key-press-event-fn
                                    (merge
                                      (dissoc props :key-press-event-fn)
                                      {:keyboard-button-press? true
                                       :regex-result regex-result}))]
              (when (vector? function-result)
                {:fx [[:dispatch function-result]]}))))
        {:db (-> (assoc-in db [:keypad keypad-id :valid-input?] false)
               (assoc-in [:keypad keypad-id :input-prompt] (i18n/get [:keypad-reached-maximum-character-limit])))}))))

(defn is-valid-input-icon [valid?]
  [:i.fas.fade-in
   {:class (if valid? "fa-check" "fa-exclamation-triangle")
    :style {:display (when (nil? valid?) "none")
            :color (if valid? "var(--green)" "var(--red)")}}])

(defn field-control [& [props]]
  [:div.field
   (merge
     {:style {:margin-bottom "0.4rem"}}
     (:field-props props))
   (into
     [:div.control
      (when (map? props)
        (dissoc props :field-props))]
     (r/children (r/current-component)))])

(defn input [& [props]]
  (into
    [:input.input
     (merge
       (dissoc props
         :active-input?
         :valid-input?)
       {:class (str (when (and (not (nil? (:valid-input? props))) (:active-input? props))
                      (if (:valid-input? props)
                        " is-success "
                        " is-danger "))
                 (:class props))})]
    (r/children (r/current-component))))


(defn prompt-message [props prompt]
  [:p.input-prompt
   (merge
     (dissoc props :valid-input? :show-prompt?)
     {:style (merge {:transform (if (and prompt (not (= "" prompt)) (not (:hide-prompt? props)))
                                  "translateY(0) scale(1)"
                                  "translateY(-2rem) scale(0)")}
               (:style props))})
   prompt])

(defn field-input [{:keys [size
                           control-props
                           input-props
                           valid-input?
                           active-input?
                           prompt
                           prompt-props
                           icon-left
                           icon-left-props
                           icon-right
                           icon-right-props]}]
  [field-control
   (merge
     control-props
     {:class (str
               (when icon-left
                 " has-icons-left ")
               (when-not (false? icon-right)
                 " has-icons-right ")
               (:class control-props))
      :style (merge {:font-size size}
               (:style control-props))})
   [input
    (merge
      {:active-input? active-input?
       :valid-input? valid-input?}
      input-props
      {:style (merge
                {:font-size size
                 :z-index (when prompt 1)}
                (:style input-props))})]
   (when icon-left
     [(if (:on-click icon-left-props) :button.is-clickable :span)
      (merge
        {:class "icon is-left"}
        icon-left-props)
      (if (string? icon-left)
        [:i {:class icon-left}]
        icon-left)])
   (when-not (false? icon-right)
     [(if (:on-click icon-right-props) :button.is-clickable :span)
      (merge
        icon-right-props
        {:class (str (:class icon-right-props) " icon is-right ")
         :style (merge (when (:on-click icon-right-props) {:pointer-events "auto"})
                  (:style icon-right-props))})
      (if icon-right
        (if (string? icon-right)
          [:i {:class icon-right}]
          icon-right)
        (when active-input?
          [is-valid-input-icon valid-input?]))])
   [prompt-message
    (merge prompt-props
      {:class (str (:class prompt-props)
                (cond
                  valid-input?
                  " is-success "
                  (false? valid-input?)
                  " is-danger "
                  (nil? valid-input?)
                  " is-info "
                  :else nil))})
    prompt]])

(defonce variables (r/atom (or (interop/local-storage :get-item :input-variables) {})))

(rf/reg-sub :radio
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:radio id] nil)
      (:radio @variables))))

(rf/reg-sub :checkbox
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:checkbox id] nil)
      (:checkbox @variables))))

(rf/reg-sub :multi-slider
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:multi-slider id] nil)
      (:multi-slider @variables))))

(rf/reg-sub :slider
  (fn [_ [_ id]]
    (if id
      (get-in @variables [:slider id] nil)
      (:slider @variables))))

(defn radio [& [props]]
  (into
    [:label.panel-block
     [:input
      (merge
        (when (map? props) props)
        {:on-change (fn [event]
                      (when (fn? (:on-change props))
                        ((:on-change props) event))
                      (let [updated-vars (assoc-in @variables [:radio (:name props)] (:value props))]
                        (rf/dispatch [:local-storage :set-item :input-variables updated-vars])
                        (reset! variables updated-vars)))
         :type "radio"})]]
    (r/children (r/current-component))))

(defn checkbox [& [props]]
  (let [checkbox-key (or (:checkbox-key props) (:id props) :default-checkbox-key)]
    (into
      [:label.panel-block
       {:class (:outer-class props)
        :style (:outer-style props)}
       [:input
        (merge
          (when (map? props) (dissoc props
                               :outer-style
                               :outer-class
                               :checkbox-key))
          {:on-key-up (fn [event]
                        (when (fn? (:on-key-up props))
                          ((:on-key-up props) event))
                        (when (or (= event.key "Enter") (= event.keyCode 13))
                          (let [updated-vars (assoc-in @variables [:checkbox checkbox-key] (not (.-checked (.-target event))))]
                            (rf/dispatch [:local-storage :set-item :input-variables updated-vars])
                            (reset! variables updated-vars))))
           :on-change (fn [event]
                        (when (fn? (:on-change props))
                          ((:on-change props) event))
                        (let [updated-vars (assoc-in @variables [:checkbox checkbox-key] (.-checked (.-target event)))]
                          (rf/dispatch [:local-storage :set-item :input-variables updated-vars])
                          (reset! variables updated-vars)))
           :checked (if (nil? (get-in @variables [:checkbox checkbox-key] nil))
                      (if (nil? (:checked props)) false (:checked props))
                      (get-in @variables [:checkbox checkbox-key] nil))
           :type "checkbox"})]]
      (r/children (r/current-component)))))

(defn switch [& [props]]
  (into
    [checkbox
     (merge
       (when (map? props) props)
       {:class (str (:class props) " is-switch ")})]
    (r/children (r/current-component))))

(defn slider [{:keys [text-bubble-width text-bubble-height width min max default-value text-bubble-child] :as props}]
  (let [id (or (:id props) (:key props))
        width (or (if (string? width) (js/parseInt width) width) 40)
        min (or (if (string? min) (js/parseInt min) min) 0)
        max (or (if (string? min) (js/parseInt max) max) 100)
        step-length (- max min)
        width-per-step (/ width step-length)
        thumb-width 2.5
        text-bubble-width (or text-bubble-width 3)
        text-bubble-height (or text-bubble-height 2)
        cancel-button-width 3
        margin 1.5
        value (or (get-in @variables [:slider id] nil) default-value)
        value-fallback (or (- value min) 0)
        show-cross-button? (not (= default-value value))]
    [:div
     {:style {:width (str (+ margin margin width) "rem")
              :height "3.75rem"
              :margin (str (inc text-bubble-height) "rem auto " cancel-button-width "rem auto")}}
     [:div
      {:style {:position "relative"
               :width (str width "rem")}}
      [:div.notification
       {:class (:class props)
        :style {:position "absolute"
                :z-index "4"
                :top (str "-" (+ 0.5 text-bubble-height) "rem")
                :display "flex"
                :justify-content "center"
                :align-items "center"
                :flex-direction "column"
                :border-radius "0.5rem"
                :border (when-not (:class props) "solid 1px var(--primary-brand-color)")
                :margin 0
                :padding 0
                :pointer-events "none"
                :height (str text-bubble-height "rem")
                :left (str (+ (* (- (+ margin (/ thumb-width 2)) (/ text-bubble-width 2)) (- 1 (/ value-fallback step-length)))
                             (* (- (- margin (/ thumb-width 2)) (/ text-bubble-width 2)) (/ value-fallback step-length))
                             (* width-per-step value-fallback)) "rem")
                :width (str text-bubble-width "rem")}}
       (if (vector? text-bubble-child)
         text-bubble-child
         [:p.help
          {:style {:margin "0"
                   :text-align "center"}}
          (if (string? text-bubble-child)
            text-bubble-child
            value)])]
      (when show-cross-button?
        [:button.is-clickable.icon.is-danger.is-rounded.fade-in
         {:style {:position "absolute"
                  :z-index "4"
                  :top (str (+ margin (/ thumb-width 2)) "rem")
                  :left (str (+ (* (- (/ thumb-width 2) 1) (- 1 (/ value-fallback step-length)))
                               (* (- (+ 1 (/ thumb-width 2))) (/ value-fallback step-length))
                               (* width-per-step value-fallback)) "rem")
                  :width (str cancel-button-width "rem")
                  :height (str cancel-button-width "rem")
                  :margin "1rem"}
          :on-click #(do (swap! variables assoc-in [:slider id] default-value)
                         (when (fn? (:on-click props))
                           ((:on-click props) default-value)))}
         [:i.fas.fa-times-circle.fa-2x]])
      [:input.slider
       {:class (:class props)
        :type "range"
        :min min
        :max max
        :step "1"
        :style {"--thumb-width" (str thumb-width "rem")
                "--thumb-height" (str thumb-width "rem")
                :position "absolute"
                :top (str margin "rem")
                :left (str margin "rem")
                :z-index "3"}
        :value value
        :on-change (fn [event]
                     (let [value (js/parseInt (-> event .-target .-value))]
                       (swap! variables assoc-in [:slider id] value)
                       (when (fn? (:on-change props))
                         ((:on-change props) value))))}]]]))

(defn multi-slider [{:keys [text-bubble-width text-bubble-height width min max inverse-allowed?
                            default-value-1 default-value-2 text-bubble-child-1 text-bubble-child-2] :as props}]
  (let [id (or (:id props) (:key props))
        width (or width 40)
        min (or min 0)
        max (or max 100)
        step-length (- max min)
        width-per-step (/ width step-length)
        thumb-width 2.5
        text-bubble-width (or text-bubble-width 3)
        text-bubble-height (or text-bubble-height 2)
        cancel-button-width 3
        margin 1.5
        value-1 (or (get-in @variables [:multi-slider id :value-1] nil) default-value-1)
        value-2 (or (get-in @variables [:multi-slider id :value-2] nil) default-value-2)
        value-1-fallback (or (- value-1 min) min)
        value-2-fallback (or (- value-2 min) max)
        show-cross-button-1? (not (= default-value-1 value-1))
        show-cross-button-2? (not (= default-value-2 value-2))]
    [:div
     {:style {:width (str (+ margin margin width) "rem")
              :height "3.75rem"
              :margin (str text-bubble-height "rem auto" cancel-button-width "rem auto")}}
     [:div
      {:style {:position "relative"
               :width (str width "rem")}}
      [:div
       {:style {:position "absolute"
                :z-index "1"
                :top "0"
                :background "var(--scheme-invert)"
                :pointer-events "none"
                :height "0.75rem"
                :border-radius "1rem"
                :width "100%"
                :margin (str margin "rem")}}]
      [:div
       {:style {:position "absolute"
                :z-index "2"
                :top "0"
                :border-radius "1rem"
                :background-color "var(--success)"
                :pointer-events "none"
                :height "0.75rem"
                :left (if (>= value-1 value-2-fallback)
                        "0"
                        (str (* width-per-step value-1-fallback) "rem"))
                :width (if (>= value-1-fallback value-2-fallback)
                         (str (* width-per-step value-2-fallback) "rem")
                         (str (* width-per-step (Math/abs (- value-2-fallback value-1-fallback))) "rem"))
                :margin (str margin "rem")}}]
      [:div
       {:style {:position "absolute"
                :z-index "2"
                :top "0"
                :border-radius "1rem"
                :background-color "var(--success)"
                :pointer-events "none"
                :height "0.75rem"
                :left (if (>= value-1-fallback value-2-fallback)
                        (str (* width-per-step value-1-fallback) "rem")
                        (str (* width-per-step value-1-fallback) "rem"))
                :width (if (>= value-1-fallback value-2-fallback)
                         (str (* width-per-step (Math/abs (- max value-1-fallback))) "rem")
                         (str (* width-per-step (Math/abs (- value-2-fallback value-1-fallback))) "rem"))
                :margin (str margin "rem")}}]
      [:div
       {:style {:position "absolute"
                :z-index "4"
                :top (str "-" (+ 0.5 text-bubble-height) "rem")
                :display "flex"
                :justify-content "center"
                :align-items "center"
                :flex-direction "column"
                :border-radius "0.5rem"
                :border "solid 1px var(--primary-brand-color)"
                :background "var(--background)"
                :pointer-events "none"
                :height (str text-bubble-height "rem")
                :left (str (+ (* (- (+ margin (/ thumb-width 2)) (/ text-bubble-width 2)) (- 1 (/ value-1-fallback step-length)))
                             (* (- (- margin (/ thumb-width 2)) (/ text-bubble-width 2)) (/ value-1-fallback step-length))
                             (* width-per-step value-1-fallback)) "rem")
                :width (str text-bubble-width "rem")}}
       (if (vector? text-bubble-child-1)
         text-bubble-child-1
         [:p.help
          {:style {:margin "0"
                   :text-align "center"}}
          (if (string? text-bubble-child-1)
            text-bubble-child-1
            value-1-fallback)])]
      (when show-cross-button-1?
        [:button.is-clickable.icon.is-danger.is-rounded.fade-in
         {:style {:position "absolute"
                  :z-index "4"
                  :top (str (+ margin (/ thumb-width 2)) "rem")
                  :left (str (+ (* (- (/ thumb-width 2) 1) (- 1 (/ value-1-fallback step-length)))
                               (* (- (+ 1 (/ thumb-width 2))) (/ value-1-fallback step-length))
                               (* width-per-step value-1-fallback)) "rem")
                  :width (str cancel-button-width "rem")
                  :height (str cancel-button-width "rem")
                  :margin "1rem"}
          :on-click #(do (swap! variables assoc-in [:multi-slider id :value-1] default-value-1)
                         (when (fn? (:on-click-1 props))
                           ((:on-click-1 props) default-value-1)))}
         [:i.fas.fa-times-circle.fa-2x]])
      [:div
       {:style {:position "absolute"
                :z-index "4"
                :top (str "-" (+ 0.5 text-bubble-height) "rem")
                :display "flex"
                :justify-content "center"
                :align-items "center"
                :flex-direction "column"
                :border-radius "0.5rem"
                :border "solid 1px var(--primary-brand-color)"
                :background "var(--background)"
                :pointer-events "none"
                :height (str text-bubble-height "rem")
                :left (str (+ (* (- (+ margin (/ thumb-width 2)) (/ text-bubble-width 2)) (- 1 (/ value-2-fallback step-length)))
                             (* (- (- margin (/ thumb-width 2)) (/ text-bubble-width 2)) (/ value-2-fallback step-length))
                             (* width-per-step value-2-fallback)) "rem")
                :width (str text-bubble-width "rem")}}
       (if (vector? text-bubble-child-2)
         text-bubble-child-2
         [:p.help
          {:style {:margin "0"
                   :text-align "center"}}
          (if (string? text-bubble-child-2)
            text-bubble-child-2
            value-2-fallback)])]
      (when show-cross-button-2?
        [:button.is-clickable.icon.is-danger.is-rounded.fade-in
         {:style {:position "absolute"
                  :z-index "4"
                  :top (str (+ margin (/ thumb-width 2)) "rem")
                  :left (str (+ (* (- (/ thumb-width 2) 1) (- 1 (/ value-2-fallback step-length)))
                               (* (- (+ 1 (/ thumb-width 2))) (/ value-2-fallback step-length))
                               (* width-per-step value-2-fallback)) "rem")
                  :width (str cancel-button-width "rem")
                  :height (str cancel-button-width "rem")
                  :margin "1rem"}
          :on-click #(do (swap! variables assoc-in [:multi-slider id :value-2] default-value-1)
                         (when (fn? (:on-click-2 props))
                           ((:on-click-2 props) default-value-2)))}
         [:i.fas.fa-times-circle.fa-2x]])
      [:input.slider
       {:class (or (:class-1 props) (:class props))
        :type "range"
        :min min
        :max max
        :step "1"
        :style {:pointer-events "none"
                "--thumb-width" (str thumb-width "rem")
                "--thumb-height" (str thumb-width "rem")
                :position "absolute"
                :top (str margin "rem")
                :left (str margin "rem")
                :z-index "3"
                :background "transparent"}
        :value (or value-1 min)
        :on-change (fn [event]
                     (let [value (js/parseInt (-> event .-target .-value))]
                       (if inverse-allowed?
                         (do (swap! variables assoc-in [:multi-slider id :value-1] value)
                             (when (fn? (:on-change-1 props))
                               ((:on-change-1 props) value)))
                         (when (<= value value-2-fallback)
                           (swap! variables assoc-in [:multi-slider id :value-1] value)
                           (when (fn? (:on-change-1 props))
                             ((:on-change-1 props) value))))))}]
      [:input.slider
       {:class (or (:class-2 props) (:class props))
        :type "range"
        :min min
        :max max
        :step "1"
        :style {:position "absolute"
                "--thumb-width" (str thumb-width "rem")
                "--thumb-height" (str thumb-width "rem")
                :top (str margin "rem")
                :left (str margin "rem")
                :z-index "3"
                :background "transparent"
                :pointer-events "none"}
        :value (or value-2 max)
        :on-change (fn [event]
                     (let [value (js/parseInt (-> event .-target .-value))]
                       (if inverse-allowed?
                         (do (swap! variables assoc-in [:multi-slider id :value-2] value)
                             (when (fn? (:on-change-2 props))
                               ((:on-change-2 props) value)))
                         (when (>= value value-1-fallback)
                           (swap! variables assoc-in [:multi-slider id :value-2] value)
                           (when (fn? (:on-change-2 props))
                             ((:on-change-2 props) value))))))}]]]))
